import React from 'react';
import { renderBodyHtml } from '@/lib/renderBodyHtml';
// 見た目のクラスは管理画面のプレビュー（HtmlRendererClient）とも共有する
import { richTextClassName } from '@/lib/richTextClasses';

type Props = {
  html: string;
  className?: string;
};

/**
 * HtmlRenderer
 * 目的: HTML文字列をサニタイズして安全に描画する（TipTap出力を想定）
 *
 * 引数:
 * - html: HTML文字列
 *
 * 戻り値:
 * - ReactNode
 *
 * 想定される例外:
 * - サニタイズ処理が失敗する可能性は低いが、表示崩れ時は入力HTMLを確認
 */
export function HtmlRenderer({ html, className }: Props) {
  const safe = renderBodyHtml(html ?? '', 'adminPost');

  return (
    <div
      className={richTextClassName(className)}
      dangerouslySetInnerHTML={{ __html: safe }}
    />
  );
}

/**
 * MemberPostHtmlRenderer
 * 目的: 会員が書いたブログ本文のHTMLを、HtmlRenderer と同じタイポグラフィで安全に描画する
 *
 * HtmlRenderer との違いは renderBodyHtml に渡す variant のみ（'memberPost' ＝許可タグが狭く、
 * 画像は結会が配信しているホストのものだけ通す）。見た目のクラスは共有する。
 *
 * 引数:
 * - html: HTML文字列（会員が書いた記事本文）
 *
 * 戻り値:
 * - ReactNode
 */
export function MemberPostHtmlRenderer({ html, className }: Props) {
  const safe = renderBodyHtml(html ?? '', 'memberPost');

  return (
    <div
      className={richTextClassName(className)}
      dangerouslySetInnerHTML={{ __html: safe }}
    />
  );
}
